import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { ChatWidgetLocaleContextConsumer } from './ChatWidgetLocaleContext';
import { UPDATED_VISITOR_WIDGET_BORDER_RADIUS } from '../widget-dimensions/constants/dimensions';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConsentModalContainer = styled.div.withConfig({
  displayName: "ConsentModal__ConsentModalContainer"
})(["position:absolute;height:100%;display:flex;align-items:flex-start;justify-content:center;width:100%;background-color:rgba(45,62,80,0.79);backdrop-filter:blur(2px);padding-top:20px;border-bottom-left-radius:", "px;border-bottom-right-radius:", "px;overflow-y:hidden;"], UPDATED_VISITOR_WIDGET_BORDER_RADIUS, UPDATED_VISITOR_WIDGET_BORDER_RADIUS);
const ContentContainer = styled.div.withConfig({
  displayName: "ConsentModal__ContentContainer"
})(["display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;padding:20px;background-color:white;border-radius:3px;box-shadow:0 2px 4px -1px rgba(0,0,0,0.75);margin:0 20px;"]);
const SmallNoParagraphPadding = styled(VizExSmall).withConfig({
  displayName: "ConsentModal__SmallNoParagraphPadding"
})(["display:block;max-height:272px;word-break:break-word;word-wrap:break-word;-ms-word-break:break-all;p{margin-bottom:0;}overflow-y:auto;"]);
const FullWidthButton = styled(VizExButton).withConfig({
  displayName: "ConsentModal__FullWidthButton"
})(["padding:9px 16px;margin:0 auto;width:fit-content;flex:0 0 auto;border-radius:999px;&:not(:first-child){margin-left:8px;}"]);
const ButtonsContainer = styled.div.withConfig({
  displayName: "ConsentModal__ButtonsContainer"
})(["display:flex;flex-direction:row;margin:12px 0 0 0;width:100%;"]);
const Header = styled.p.withConfig({
  displayName: "ConsentModal__Header"
})(["text-transform:none;font-size:18px;font-weight:500;margin-top:18px;margin-bottom:12px;line-height:normal;"]);
const ConsentModal = ({
  headerMessage,
  message,
  onClick = () => {},
  onDeclineClick = () => {}
}) => {
  const [state, setState] = useState({
    isEntering: true,
    shouldRender: true,
    callback: () => {}
  });
  const onAnimationEnd = () => {
    if (!state.isEntering) {
      state.callback();
      setState(Object.assign({}, state, {
        shouldRender: false
      }));
    }
  };
  const onClose = cb => {
    setState(Object.assign({}, state, {
      isEntering: false,
      callback: cb
    }));
  };
  if (!state.shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(ConsentModalContainer, {
    style: {
      animation: `${state.isEntering ? 'consent-modal-background-fadeIn' : 'consent-modal-background-fadeOut'} .3s`
    },
    "data-test-id": "gdpr-consent-prompt-container",
    onAnimationEnd: onAnimationEnd,
    children: /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
      children: locale => /*#__PURE__*/_jsxs(ContentContainer, {
        "data-test-id": "gdpr-consent-prompt",
        style: {
          animation: `${state.isEntering ? 'consent-modal-content-fadeIn' : 'consent-modal-content-fadeOut'} .3s`
        },
        children: [headerMessage && /*#__PURE__*/_jsx(Header, {
          children: headerMessage
        }), /*#__PURE__*/_jsx(SmallNoParagraphPadding, {
          use: "help",
          role: "document",
          tabIndex: 0,
          "data-test-id": "gdpr-consent-text",
          dangerouslySetInnerHTML: {
            __html: formatHtml(message)
          }
        }), /*#__PURE__*/_jsxs(ButtonsContainer, {
          children: [/*#__PURE__*/_jsx(FullWidthButton, {
            onClick: () => {
              onClose(onClick);
            },
            "data-test-id": "gdpr-consent-agree-button",
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-visitor-experience-components.buttons.agree",
              options: {
                locale
              }
            })
          }), /*#__PURE__*/_jsx(FullWidthButton, {
            onClick: () => {
              onClose(onDeclineClick);
            },
            "data-test-id": "gdpr-consent-dismiss-button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-visitor-experience-components.buttons.disagree",
              options: {
                locale
              }
            })
          })]
        })]
      }, "consent-modal-content-container")
    })
  }, `${Math.random}-consent-modal-container`);
};
ConsentModal.propTypes = {
  headerMessage: PropTypes.node,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onDeclineClick: PropTypes.func.isRequired
};
ConsentModal.displayName = 'ConsentModal';
export default ConsentModal;